<template>
    <div id="player" class="box" v-if="isPlaying">
        <iframe
            :src="embedSrc"
            width="300"
            height="80"
            frameborder="0"
            allowtransparency="true"
            allow="encrypted-media"
        ></iframe>
        <div class="close" @click="$store.commit('play', null)">Close</div>
    </div>
</template>

<script>
export default {
    name: "PlayerWidget",
    computed: {
        embedSrc() {
            // Create the embed url from a uri
            return `https://open.spotify.com/embed/${this.$store.state.playing
                .replace("spotify:", "")
                .replace(":", "/")}`;
        },

        isPlaying() {
            return this.$store.state.playing !== null;
        }
    }
};
</script>

<style scoped>
#player {
    background-color: green;
    position: fixed;
    bottom: 10px;
    left: 10px;
    z-index: 999;
    padding-bottom: 3px;
}

.close {
    text-align: center;
    cursor: pointer;
}
</style>
